const blacks = [
	'rgba(0, 0, 0, 0)',
	'rgba(0, 0, 0, 0.004)',
	'rgba(0, 0, 0, 0.04)',
	'rgba(0, 0, 0, 0.05)',
	'rgba(0, 0, 0, 0.06)',
	'rgba(0, 0, 0, 0.09)',
	'rgba(0, 0, 0, 0.1)',
	'rgba(0, 0, 0, 0.15)',
	'rgba(0, 0, 0, 0.19)',
	'rgba(0, 0, 0, 0.2)',
	'rgba(0, 0, 0, 0.22)',
];

const radii = {
	small: '4px',
	medium: '6px',
	large: '12px',
	xLarge: '20px',
};

const breakPoints = {
	small: '420px',
	medium: '760px',
	large: '1024px',
};

const colors = {
	containerBackground: '#f7f7f7',
	textColor: '#1a2e45',
	cadetBlue: '#B3B9C8',
	blacks,
	cloudBurst: '#22354B',
	cornflower: '#5b89ee',
	cornflowerBlue: '#788AF7',
	riverBed: '#454e62',
	zircon: '#F1F3FF',
	wildBlue: '#7F87B2',
	lightBlue: '#6463EF',
	slateBlue: '#685BC7',
	lightSteelBlue: '#b6bbd5',
	shadowBlue: '#767FAC',
	dollarBill: '#94BB5F',
	white: '#ffffff',
	'white-three': '#eeeeee',
	'ghost-white': '#f7f9ff',
	whites: [
		'rgba(255,255,255,.0125)',
		'rgba(255,255,255,.025)',
		'rgba(255,255,255,.05)',
		'rgba(255,255,255,.1)',
		'rgba(255,255,255,.2)',
		'rgba(255,255,255,.3)',
		'rgba(255,255,255,.4)',
		'rgba(255,255,255,.5)',
		'rgba(255,255,255,.6)',
		'rgba(255,255,255,.7)',
		'rgba(255,255,255,.8)',
		'rgba(255,255,255,.9)',
	],
	doveGray: '#737272',
	metalicSilver: '#A2AAB4',
	brightGrey: '#efefef',
	silverSand: '#b8becc',
	'dark-red': '#e7040f',
	red: '#f44336',
	'light-red': '#ff725c',
	pastelRed: '#ff6262',
	orange: '#ff6300',
	'royal-orange': '#fc8f3e',
	gold: '#ffb700',
	yellow: '#ffd700',
	'light-yellow': '#fbf1a9',
	purple: '#5e2ca5',
	'light-purple': '#a463f2',
	'dark-pink': '#d5008f',
	'hot-pink': ' #ff41b4',
	pink: '#ff80cc',
	'light-pink': '#ffa3d7',
	'dark-green': '#137752',
	'shiny-shamrock': '#50A684',
	locust: '#A1B08D',
	green: '#19a974',
	'light-green': '#9eebcf',
	navy: '#001b44',
	'dark-blue': '#00449e',
	blue: '#357edd',
	'steel-blue': '#326EB3',
	'light-blue': '#96ccff',
	'bright-blue': '#0433FF',
	'lightest-blue': '#cdecff',
	'washed-blue': '#f6fffe',
	'washed-green': '#e8fdf5',
	'washed-yellow': '#fffceb',
	'washed-red': '#ffdfdf',
	'yankees-blue': '#19243b',
	crayola: '#aeb5c4',
	'lavender-blue': '#bccff8',
	'police-blue': '#30516b',
	'cool-grey': '#8b94b9',
	'shade-grey': '#999',
	tomato: '#ff6347',
	gainsboro: '#d4d7e4',
	'lavender-grey': '#BBC0D8',
	'rice-flower': '#ecf7dd',
	dingley: '#637c40',
	lavender: '#f5f7fe',
	'alice-blue': '#f2f4ff',
	'border-bottom-color': 'rgba(187, 192, 216, 0.18)',
	'tag-background-color': 'rgba(221, 227, 255, 0.39)',
	'box-border-color': '#f4f5f7',
	'very-cool-grey': '#848DB4',
	'azureish-white': '#d6ddf3',
	'spring-bud': '#e5fac8',
	independance: '#43536D',
	'alicia-blue': '#eaf1ff',
	'misty-rose': '#FFE8E8',
};
const fontSizes = [
	'10px',
	'11px',
	'12px',
	'13px',
	'14px',
	'15px',
	'16px',
	'18px',
	'20px',
	'24px',
	'28px',
];

const flexboxBorderBottom = `solid 1px ${colors['border-bottom-color']}`;
const boxBorderTop = `3px solid ${colors['box-border-color']}`;
const boxBorderLeft = `1px solid ${colors['box-border-color']}`;

export default {
	colors,
	fontSizes,
	shadows: {
		small: `0 2px 2px 0 ${blacks[5]}`,
		medium: `0 2px 4px 0 ${blacks[1]}`,
		large: `0 8px 8px 0 ${blacks[5]}`,
	},
	paragraph: {
		demoSection: { fontSize: fontSizes[6], color: colors.cadetBlue, fontWeight: 500 },
		setupSyncError: {
			pt: '5px',
			pb: '5px',
			pr: '5px',
			mt: '5px',
			borderRadius: '4px',
			backgroundColor: colors.zircon,
			color: colors.wildBlue,
		},
	},
	heading: {
		setUpTitle: {
			fontSize: fontSizes[7],
			fontWeight: 'bold',
			letterSpacing: 0,
			color: colors.riverBed,
			mb: '15px',
			textAlign: 'center',
		},
		subHeadingDefault: {
			fontWeight: 'bold',
			fontSize: fontSizes[6],
		},
	},
	actionButtonsLayout: {
		flexDirection: 'column',
		justifyContent: 'center',
		background: colors['alice-blue'],
	},
	assignedFundraiserList: {
		fontSize: fontSizes[3],
		color: colors.doveGray,
	},
	radii,
	breakPoints,
	flexboxBorderBottom,
	boxBorderTop,
	boxBorderLeft,
};



// WEBPACK FOOTER //
// ./src/lib/theme.js